import React, { HTMLAttributes } from 'react';

import clsx from 'clsx';

import { Text } from '@atoms';

import classes from './nav-toggle.module.scss';

export type ToggleProps = {
  isOpen: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const NavToggle = ({ isOpen }: ToggleProps) => {
  return (
    <>
      <div className={clsx(classes.navToggle, isOpen && classes.navToggleOpen)}>
        <span></span>
        <span></span>
        <span></span>
        <span></span>

        <Text
          className={classes.navText}
          message={{ id: `nav.${isOpen ? 'close' : 'open'}` }}
          margin={0}
        />
      </div>
    </>
  );
};
